<template>
  <el-col :xs="xs" :sm="sm">
    <span class="field">{{ $t('common.websiteCid') }}</span>
    <KkSelectWithMenu
      v-model="cid" 
      placeholder="placeholder"
      :is-filterable="true"
      :is-disabled="disabled || specifyCid !== ''"
      @change="onChange"
    >
      <KkSelectOption
        v-for="item in websiteList"
        :key="item.affiliate_member_web_oid"
        :label="specifyCid ? `${item.cid}` : `${item.site_name}-${item.cid}`"
        :value="item.cid"
      />
    </KkSelectWithMenu>

  </el-col>
</template>

<script>
import { KkSelectWithMenu, KkSelectOption } from '@kkday/web-design-system'
import { getWebsiteList } from '@/api/affiliate'

export default {
  components: {
    KkSelectWithMenu,
    KkSelectOption
  },
  props: {
    value: {
      type: [Number, String]
    },
    xs: {
      type: Number,
      default: 24
    },
    sm: {
      type: Number,
      default: 6
    },
    disabled: {
      type: Boolean,
      default: false
    },
    specifyCid: {
      default: ''
    },
    activeCid: {
      default: ''
    }
  },
  data() {
    return {
      cid: '',
      websiteList: []
    }
  },
  created() {
    this.queryWebsite()
  },
  methods: {
    queryWebsite() {
      getWebsiteList().then(res => {
        if (res?.metadata?.status === '0000') {
          this.websiteList = res?.data?.list || []
          if (this.specifyCid) {
            this.cid = this.specifyCid
            this.websiteList = [{
              cid: this.specifyCid,
              name: this.site_name
            }]
          } else if(this.activeCid) {
            this.cid = Number(this.activeCid)
          } else {
            this.cid = this.websiteList[0]?.cid
          }
          this.$emit('input', this.cid)
        }
      })
    },
    onChange() {
      this.$emit('input', this.cid)
      this.$emit('change', this.cid)
    }
  }
}
</script>

<style lang="less" scoped>
.field {
  display: inline-block;
  margin-bottom: 3px;
  font-size: var(--kk-font-size-2);
}
</style>
